const actions = {
  SET_STATE: 'teams/SET_STATE',
  TEAM_COLLABORATOR_LIST: 'teams/TEAM_COLLABORATOR_LIST',
  TEAM_COLLABORATOR_INVITE: 'teams/TEAM_COLLABORATOR_INVITE',
  TEAM_COLLABORATOR_REMOVE: 'teams/TEAM_COLLABORATOR_REMOVE',
  TEAM_COLLABORATOR_CHANGE_ROLE: 'teams/TEAM_COLLABORATOR_CHANGE_ROLE',
  TEAM_COLLABORATOR_LEAVE: 'teams/TEAM_COLLABORATOR_LEAVE',
  TEAM_TRANSFER_OWNERSHIP: 'teams/TEAM_TRANSFER_OWNERSHIP',
  ENTER_TEAM_COLLABORATOR_TEXT: 'teams/ENTER_TEAM_COLLABORATOR_TEXT',
  SEARCH_TEAM_COLLABORATOR: 'teams/SEARCH_TEAM_COLLABORATOR',
}

export default actions
